export default function initShowPassword() {
	const triggerElements = document.querySelectorAll('.js-show-password__trigger')

	if (!triggerElements.length) {
		return
	}

	triggerElements.forEach(element => {
		element.addEventListener('click', function () {
			const targetElem = element
				.closest('.ca-input__icon-input')
				?.querySelector('.js-show-password__target') as HTMLInputElement

			if (targetElem) {
				const isPassword = targetElem.getAttribute('type') === 'password'

				targetElem.setAttribute('type', isPassword ? 'text' : 'password')
			}
		})
	})
}
